import { iconFactory } from '../iconFactory'

export const Conditions = iconFactory('Conditions', ({ fill }) => (
  <path
    d="M3.66498 17V19H9.66498V17H3.66498ZM3.66498 5V7H13.665V5H3.66498ZM13.665 21V19H21.665V17H13.665V15H11.665V21H13.665ZM7.66498 9V11H3.66498V13H7.66498V15H9.66498V9H7.66498ZM21.665 13V11H11.665V13H21.665ZM15.665 9H17.665V7H21.665V5H17.665V3H15.665V9Z"
    fill={fill}
  />
))
